import React, { useEffect, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { TfiClose } from 'react-icons/tfi';
import { IoSearchSharp } from "react-icons/io5";
import { CiCircleRemove } from 'react-icons/ci';
import { IncidentOrDeviationApi } from '../../../service/deviation';
import AlertModal from '../../../widgets/alertModal';
import CustomToast from '../../../widgets/toaster';
import { helperFunctions } from '../../../utils/helper';
import CustomLoader from '../../../widgets/loader/loader';


interface AddExceptionModelProps {
  show: boolean;
  setShow: () => void;
  reason: any
  setUseEffectRequired: (value: boolean) => void;

}


const AddDeviationModel: React.FC<AddExceptionModelProps> = ({
  show,
  setShow,
  reason,
  setUseEffectRequired
}) => {

  // const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const scanAreaRef = useRef<HTMLInputElement>(null);


  const [scanCode, setScanCode] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("success");
  const [toastType, setToastType] = useState("success");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedSerielNo, setSelectedSerielNo] = useState("");
  const [addAreaData, setAddAreaData] = useState({
    id: "",
    area_code: "",
    name: "",
  });
  const [deviationAlert, AddDeviationAlert] = useState(false);
  const [formData, setFormData] = useState({
    reason: '',
    remarks: '',
  });
  //handle error section
  interface Errors {
    equipmentCode?: string;
    reason?: string;
  }
  const [errors, setErrors] = useState<Errors>({});

  // get area by id
  const getAreaById = async (Id: string) => {
    try {
      const response = await IncidentOrDeviationApi.getAreaId(Id);
      if (response.status && response.statusCode === 200) {
        setAddAreaData({
          id: response.data.id,
          area_code: response.data.area_code,
          name: response.data.name,
        });
      }
    } catch (error) {
      console.error('user response', error);
    }
  }

  // get area by location code
  const getAreaByLocationCode = async (Id: string) => {
    setIsLoading(true);
    try {
      const response = await IncidentOrDeviationApi.getAreaByLocationCode(Id);
      if (response.status && response.statusCode === 200) {
        setAddAreaData({
          id: response.data.id,
          area_code: response.data.area_code,
          name: response.data.name,
        });
      }
    } catch (error) {
      console.error('user response', error);
    }finally {
      setIsLoading(false);
    }
  }

  //pass the obtained serial number to the api 
  const handleScanSerielNo = (result: any) => {
    try {
      const parsedResult = JSON.parse(result);
      const code = parsedResult.code || parsedResult.CODE
      setScanCode(code);
      if (typeof parsedResult === 'object') {
        setScanCode(code);
        webCamScan(result)
      }
    } catch (error) {
      console.error('Error parsing JSON:', error);
    }
  };

  // handle web cam scan
  const webCamScan = (result: any) => {
    if (result) {
      const scanData = JSON.parse(result);
      const id = scanData.id || scanData.ID
      if (id) {

        getAreaById(id);

      } else {
        getAreaById(id);
      }
    }
  };

  // handle cancel
  const handleCancel = () => {
    setAddAreaData({
      id: "",
      area_code: "",
      name: "",
    })
    setScanCode("")
    setSelectedSerielNo("")
    setShow();
    setFormData({
      reason: '',
      remarks: '',
    })
    setErrors({});
  }

  // handle submit
  const handleSubmit = async () => {
    const dataToSend = {
      "location_id": addAreaData.id,
      "reason_id": formData.reason,
      "remarks": formData.remarks,
    }

    try {
      const response = await IncidentOrDeviationApi.SaveDeviation(dataToSend);
      if (response.status && response.statusCode === 200) {
        setToastMessage(response.message)
        setToastType("success")
        handleCancel();
        setUseEffectRequired(true)
      } else {
        setToastMessage(response.message)
        setToastType("error")
      }
      setShowToast(true)

      AddDeviationAlert(false)
    } catch (error) {
      console.error("user response", error);
    }
  }

  // handle alert error
  const handleErrorSubmit = () => {
    const errors: Errors = {};
    if (!addAreaData.area_code) {
      errors.equipmentCode = t('deviationIncident.errors.scan');
    }
    if (!formData.reason) {
      errors.reason = t('deviationIncident.errors.reason');
    }

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    AddDeviationAlert(true)
    setErrors({});
  }

  // handle value change
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // check special charecter validation
  const checkSpecialChar = (e: any) => {
    if (!/[0-9a-zA-Z]/.test(e.key)) {
      e.preventDefault();
    }
  };

  // render all initial apis
  useEffect(() => {
    if (show === true && scanAreaRef.current) {
      scanAreaRef.current.focus();
    }
  }, [show])

  return (
    <>
      <CustomToast
        show={showToast}
        onClose={() => setShowToast(false)}
        delay={5000}
        message={toastMessage}
        toastType={toastType}
      />

      <Modal
        className="top-right-modal"
        centered={false}
        show={show}
        size="lg"
      >
        <div>
          <div className="modalHead">
            <p className="modalHeadText ms-3 pt-3 p-2">
              {t('deviationIncident.addDeviadtionIncident')}
            </p>
            <div onClick={() => handleCancel()} className="p-2 mx-3 my-2 wrapCloseIcon">
              <TfiClose fill="#FFFFFF" />
            </div>
          </div>

          <div className='d-flex'>


            <div className="scanWrap pt-3" style={{ "width": "45%" }}>
              <label style={{ "display": "flex" }}>{t('deviationIncident.scanCode')}
                <span style={{ color: "red" }}> *</span>
              </label>
              <div className="scanInputWrap p-2">
                <input
                  onChange={(e) => handleScanSerielNo(e.target.value)}
                  placeholder={t('deviationIncident.scanOnly')}
                  value={scanCode}
                  ref={scanAreaRef}
                />
                {scanCode && (
                  <CiCircleRemove
                    onClick={() => setScanCode("")}
                    fontSize={30}
                    color="red"
                    className="mt-1"
                    style={{ "cursor": "pointer" }}
                  />
                )}
              </div>

              {errors.equipmentCode && <p className="errorText">{errors.equipmentCode}</p>}
            </div>

            <div className="scanWrap pt-3" style={{ "width": "55%" }}>
              <label style={{ "display": "flex" }}>{t('deviationIncident.scanCode')}
                <span style={{ color: "red" }}> *</span>
              </label>
              <div className="scanInputWrap p-2">
                <input
                  onChange={(e) => setSelectedSerielNo(e.target.value)}
                  placeholder={t('deviationIncident.typeSearch')}
                />
                < IoSearchSharp
                  fontSize={25}
                  className='mt-1'
                  color='grey'
                  style={{ "cursor": "pointer" }}
                  onClick={() => getAreaByLocationCode(selectedSerielNo)}
                />
              </div>
              {isLoading && <CustomLoader />}
            </div>

          </div>


          <div className="selectWrap">
            <div className="form-group my-1 mx-5 px-3 ">
              <label htmlFor="" >
                {t('deviationIncident.areaLocation')}
              </label>
              <br />
              <input
                style={{ "width": "150%", "fontSize": "12px" }}
                className='scanInputWrap ps-1'
                type='text'
                placeholder={t('deviationIncident.areaLocation')}
                value={addAreaData.area_code}
                disabled
              />
            </div>
            <div className="form-group my-1 mx-5" style={{ "marginRight": "250px", paddingLeft: "11rem" }}>
              <label htmlFor="">
                {t('deviationIncident.areaLocationName')}
              </label>
              <br />
              <input
                style={{ "width": "150%", "fontSize": "12px" }}
                className='scanInputWrap ps-1'
                type='text'
                placeholder={t('deviationIncident.areaLocationName')}
                value={addAreaData.name}
                disabled
              />
            </div>
            <div className="form-group ms-2 ps-1 " style={{ "visibility": "hidden" }}>
              <label htmlFor="">
                {t("Exception.remarks")}
              </label>
              <br />
              <textarea
                placeholder={t("Exception.remarks")}
                className="otherReasonTextArea p-2"
                name="remarks"
              // value={formData.remarks}
              // onChange={handleChange}
              />
              {/* {errors.remarks && (
                        <p className="errorText m-0 p-0">{errors.remarks}</p>
                        )} */}
            </div>
          </div>

          <div className="selectWrap">
            <div className="form-group my-1 mx-5 px-3">
              <label htmlFor="">
                {t("Exception.reason")}<span style={{ color: "red" }}> *</span>
              </label>
              <br />
              <select
                name="reason"
                value={formData.reason}
                onChange={handleChange}
              >
                <option value="">{t("common.select")}</option>
                {reason.map((obj: any, index: any) => (
                  <option key={index} value={obj?.id}>
                    {obj?.reason}
                  </option>
                ))}
              </select>
              {errors.reason && (
                <p className="errorText m-0 p-0">{errors.reason}</p>
              )}
            </div>
            <div className="form-group my-1 mx-2" style={{ "visibility": "hidden" }} >
              <label htmlFor="">
                {t('deviationIncident.testResult')}
              </label>
              <br />
              <select
                name="plate_inspection_status"
              //   value={formData.plate_inspection_status}
              //   onChange={handleChange}
              >
                <option value="">{t("common.select")}</option>
                <option value="passed">{t('deviationIncident.passed')}</option>
                <option value="failed">{t('deviationIncident.failed')}</option>
              </select>
            </div>
            <div className="form-group ms-2 ps-1" style={{ "marginRight": "220px" }}>
              <label htmlFor="">
                {t("Exception.remarks")}
              </label>
              <br />
              <textarea
                placeholder={t("Exception.remarks")}
                className="otherReasonTextArea p-2"
                name="remarks"
                value={formData.remarks}
                onChange={handleChange}
                onKeyDown={(e) => helperFunctions.textFieldValidationCheck(e)}
              />
              {/* {errors.remarks && (
                      <p className="errorText m-0 p-0">{errors.remarks}</p>
                    )} */}
            </div>
          </div>


          <div className="bottomArea">
            <button
              onClick={() => handleCancel()}
              className="modalCancelBtn"
            >
              {t("buttons.cancel")}
            </button>
            <button
              onClick={() => handleErrorSubmit()}
              className="squareOrangeBtn3"
            >
              {t("buttons.submit")}
            </button>
            {/* <button className=' squareOrangeBtn3Disabled'   onClick={() => handleErrorSubmit()}>Submit</button> */}
          </div>


        </div>
      </Modal>

      <AlertModal
        show={deviationAlert}
        onHide={() => AddDeviationAlert(false)}
        title={t("common.alert")}
        message={t('deviationIncident.addDeviadtion')}
        onConfirm={handleSubmit}
      />
    </>


  )
}

export default AddDeviationModel;